
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useServiceUpdates = () => {
  const { user } = useAuth();
  const [serviceVersion, setServiceVersion] = useState(0);

  useEffect(() => {
    if (!user) return;

    // Listen for service updates
    const serviceChannel = supabase
      .channel('service-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'services',
          filter: `user_id=eq.${user.id}`
        },
        () => {
          console.log('Service updated, triggering refresh...');
          setServiceVersion(prev => prev + 1);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(serviceChannel);
    };
  }, [user]);

  return { serviceVersion };
};
